import React from "react";
import { useTheme } from "hooks";

export function LeftSection({ children, simplebar, height }) {
    const { theme } = useTheme();

    return (
        <div
            className='bootsrapiso'
            style={{
                width: `100%`,
                background: "white",
                overflowY: "scroll",
                overflowX: "hidden",
                minHeight: simplebar ? `80vh` : height || `calc(100vh - 160px)`,
            }}
        >
            <div style={{ background: "white", height: "15%" }}>
                {children[0]}
            </div>
            <div style={{ background: `white`, height: "85%" }}>
                {children[1]}
            </div>
        </div>
    );
}


